<template>
    <div class="aba-tabpreco">
        <div class="vertical-flow">
            <div class="listing-header mb-4">
                <div class="title-breadcrumb"></div>
                <div class="header-buttons">
                    <button
                        v-if="permissao.create && !integracao && parcelas.length > 1"
                        class="delete-btn"
                        type="button"
                        tag="button"
                        @click="ordenarPorDias()"
                    >
                        {{ $t('ordenar') }}
                    </button>
                    <button
                        v-if="permissao.create && !integracao"
                        @click="adicionarLinha()"
                        :disabled="isSaving"
                        class="save-btn"
                        type="button"
                    >
                        {{ $t('adicionar') }} {{ $t('parcela') }}
                    </button>
                    <button
                        v-if="permissao.create && !integracao"
                        @click="save()"
                        :disabled="isSaving"
                        class="save-btn"
                        type="button"
                    >
                        {{ $t('salvar') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty || parcelas.length == 0" />
                <b-table v-else :data="parcelas" class="data-table">
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{ 'excluir-field': f.key == 'excluir' }"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'dias'">
                            <v-input
                                v-model="props.row[f.key]"
                                placeholder="placeholder-preencha"
                                :maxlength="3"
                                msg="msg-campo-obrigatorio"
                                required
                                validchars="0123456789"
                                :disabled="!permissao.create || integracao"
                                class="max-width"
                            />
                        </div>
                        <div v-else-if="f.key == 'percentual'">
                            <v-money
                                placeholder="placeholder-preencha"
                                v-model="props.row[f.key]"
                                required
                                :min="0"
                                :max="100"
                                :disabled="!permissao.create || integracao"
                                suffix="%"
                                class="max-width"
                            />
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.create && !integracao"
                                class="action-button"
                                type="is-danger"
                                icon-right="delete"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t('remover')"
                            />
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                    <template #footer>
                        <div v-if="parcelas.length > 0" class="columns">
                            <div class="column is-11">
                                {{ $t('total') + ':' }}
                            </div>
                            <div class="column is-1">
                                {{ totalPercentualFormatado + '%' }}
                            </div>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import PrazopagtoparcelaService from '@/services/vendas/prazopagto/PrazopagtoparcelaService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import PrazopagtoparcelaValidation from '@/services/validations/vendas/prazopagto/PrazopagtoparcelaValidation';

export default {
    components: {
        ContainerLoader,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        parcelas: {
            deep: true,
            handler: function () {
                this.totalPercentual = 0;
                this.parcelas.map((e) => {
                    this.totalPercentual += e.percentual;
                });
                this.totalPercentualFormatado = this.getDecimal(this.totalPercentual, 2);
            },
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('PRAZOPAGTOPARCELA'),
            parcelas: [],
            fields: [
                { key: 'dias', width: '10%', sortable: false, sortFn: null, subheading: 'Total' },
                { key: 'percentual', width: null, sortable: false, sortFn: null, subheading: 20 },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new PrazopagtoparcelaService(this.$http, this.$router),
            validation: new PrazopagtoparcelaValidation(this.msgs),
            permissao: false,
            isLoading: false,
            isEmpty: false,
            isSaving: false,
            delete: null,
            showModal: false,
            numberPlusPlus: 1,
            totalPercentual: 0,
            totalPercentualFormatado: '0',
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-prazo-pagamento');

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'parcelas' },
            });
        } else {
            this.carregarDados();
        }
    },
    methods: {
        carregarDados() {
            this.isLoading = true;

            this.service
                .findAll(this.$route.params.id)
                .then(this.mapItems)
                .then((value) => {
                    this.parcelas = value;
                    this.isEmpty = this.parcelas.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados!', e);
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        mapItems(body) {
            return body.content.map((m) => {
                return {
                    idprazopagtoparcela: m.idprazopagtoparcela,
                    idprazopagtoparcelaerp: m.idprazopagtoparcelaerp,
                    idprazopagto: m.idprazopagto,
                    idempresa: m.idempresa,
                    dias: m.dias,
                    percentual: m.percentual,
                    replicapda: m.replicapda,
                    excluir: 'excluir',
                };
            });
        },
        adicionarLinha() {
            this.parcelas.push({
                idprazopagtoparcela: null,
                idprazopagtoparcelaerp: null,
                idprazopagto: +this.$route.params.id,
                idempresa: 0,
                dias: 0,
                percentual: 0,
                replicapda: 3,
                excluir: 'excluir',
            });
            this.isEmpty = false;
        },
        ordenarPorDias() {
            this.isLoading = true;
            this.parcelas.sort((a, b) => a.dias - b.dias);
            setTimeout(() => {
                this.isLoading = false;
            }, 300);
        },
        promptChangeSituacao(row) {
            this.delete = row;
            // Aviso dinâmico passado o nome do usuário
            let message = this.$t('msg-confirma-remover-n', 
                { n: this.$t('dias') + ' ' + row['dias'] + ' - ' + row['percentual'] + '%' }
            );
            this.$root.confirm({
                message: message,
                onConfirm: () => this.updateSituacaoRegistro(),
                onCancel: () => (this.delete = null),
            });
        },
        updateSituacaoRegistro() {
            var index = this.parcelas.findIndex(
                (f) => f.idprazopagtoparcela == this.delete.idprazopagtoparcela
            );
            this.parcelas.splice(index, 1);
        },
        save() {
            this.isLoading = true;

            let validated = this.validation.validate(this.parcelas);

            if (validated.percentualInvalido) {
                let msg = this.$t('percentual-fora-de-100-n', 
                    { n: this.getDecimal(validated.totalPercentual, 2) + '%' });
                this.$root.showMessage('alert', msg, true, false);
            }
            if (validated.hasInvalidPercentual) {
                this.$root.showMessage('alert', 'percentual-obrigatorio', true);
            }
            if (validated.hasInvalidDate) {
                this.$root.showMessage('alert', 'dias-obrigatorios', true);
            }
            if (validated.hasSameDate) {
                this.$root.showMessage('alert', 'dias-repetidos', true);
            }
            if (validated.invalid) {
                this.isLoading = false;
                return;
            }

            this.isSaving = true;
            this.service
                .insertBulk(this.parcelas, this.$route.params.id)
                .then((value) => {
                    if (value.message == null) {
                        this.$root.showMessage('success', 'msg-save-prazo-pagamento', true);
                    } else {
                        if (this.$t(value.message)) {
                            this.$root.showMessage('alert', value.message, true);
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally(() => {
                    this.$emit('isChanged', false);
                    this.isSaving = false;
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-tabpreco {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    .max-width {
        max-width: 150px;
    }

    @media (max-width: 760px) {
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
